import '@/shared/number-format';

import $ from 'jquery';

import resolveInitData from "@/shared/init-data";

const $messagesLink = $('#messages_link');
const $messagesLinkMobile = $('#messages_link_mobile');

if ($messagesLink.length > 0) {
    resolveInitData().then((initData) => {
        const unreadMessagesCount = initData.unread_messages_count;

        if (unreadMessagesCount === 0) {
            return;
        }

        const threshold = 99;
        const badgeText = unreadMessagesCount > threshold ? threshold+'+' : unreadMessagesCount;

        const $badge = $('<div>').addClass('badge bg-danger messages-badge w-messages-badge').text(badgeText);
        $messagesLink.append($badge);
        $messagesLink.attr('title', $messagesLink.attr('title').replace('0', unreadMessagesCount.format()));

        const $badgeMobile = $('<span>').addClass('badge bg-danger w-messages-badge').text(badgeText);
        $messagesLinkMobile.append($badgeMobile);
        $messagesLinkMobile.attr('title', $messagesLinkMobile.attr('title').replace('0', unreadMessagesCount.format()));
    });
}
